import styled from "styled-components";
import { homePageProductListings } from "../../data";
import Product from "./Product";
const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
 
`;

const ProductListingContainer = styled.div`
  margin: 25px;
   
`;

const ListTitle = styled.h2`
  margin-left: 25px;
  margin-top: 30px;
  color: #6e6969;
  border-left: 3px solid orange;
  padding-left: 2px;
`

const Products = () => {
  return (
    <ProductListingContainer>
      {homePageProductListings.map((list) => (
        <div key={list.id}>
          <ListTitle>{list.listTitle}</ListTitle>
          <Container>
            {list.products.map((item) => (
              <Product item={item} key={item.id} />
            ))}
          </Container>
        </div>
      ))}
      {homePageProductListings.map((list) => (
        <div key={list.id}>
          <ListTitle>{list.listTitle}</ListTitle>
          <Container>
            {list.products.map((item) => (
              <Product item={item} key={item.id} />
            ))}
          </Container>
        </div>
      ))}
      {homePageProductListings.map((list) => (
        <div key={list.id}>
          <ListTitle>{list.listTitle}</ListTitle>
          <Container>
            {list.products.map((item) => (
              <Product item={item} key={item.id} />
            ))}
          </Container>
        </div>
      ))}
      {homePageProductListings.map((list) => (
        <div key={list.id}>
          <ListTitle>{list.listTitle}</ListTitle>
          <Container>
            {list.products.map((item) => (
              <Product item={item} key={item.id} />
            ))}
          </Container>
        </div>
      ))}
      {homePageProductListings.map((list) => (
        <div key={list.id}>
          <ListTitle>{list.listTitle}</ListTitle>
          <Container>
            {list.products.map((item) => (
              <Product item={item} key={item.id} />
            ))}
          </Container>
        </div>
      ))}
    </ProductListingContainer>
  );
};

export default Products;
